module.exports = __webpack_public_path__ + "img/home-page.9261f691.png";